"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveWalletRequestBodyToJSON = exports.RemoveWalletRequestBodyFromJSONTyped = exports.RemoveWalletRequestBodyFromJSON = void 0;
function RemoveWalletRequestBodyFromJSON(json) {
    return RemoveWalletRequestBodyFromJSONTyped(json, false);
}
exports.RemoveWalletRequestBodyFromJSON = RemoveWalletRequestBodyFromJSON;
function RemoveWalletRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'walletId': json['walletId'],
    };
}
exports.RemoveWalletRequestBodyFromJSONTyped = RemoveWalletRequestBodyFromJSONTyped;
function RemoveWalletRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'walletId': value.walletId,
    };
}
exports.RemoveWalletRequestBodyToJSON = RemoveWalletRequestBodyToJSON;
